<template>
    <div class="pp-lottery-winnings">
        <DsTable>
            <DsRow>
                <DsCell type="th">Pořadí</DsCell>
                <DsCell type="th">Výhra</DsCell>
            </DsRow>
            <DsRow v-for="(winning, index) in results.mainGameWinnings[0]" :key="index">
                <DsCell>{{ index + 1 }}.&nbsp;pořadí</DsCell>
                <DsCell>
                    <div v-if="winning.amount && winning.wins">
                        <strong v-html="StringUtils.formatCurrency(winning.amount)"></strong>
                        <span v-html="formatNumberOfWinners(winning.wins)"></span>
                    </div>
                    <template v-else>–––</template>
                </DsCell>
            </DsRow>
        </DsTable>

        <PpAddonWinnings
            v-if="results.addonWinnings"
            :lottery="Lottery.euromiliony"
            :winnings="results.addonWinnings"
        ></PpAddonWinnings>

        <PpSpecialPrizeWinnings
            :lottery="Lottery.euromiliony"
            :specialPrizes="results.specialPrizes"
        ></PpSpecialPrizeWinnings>
    </div>
</template>

<script lang="ts" setup>
import { PpDraw } from "@/lotteries/services/model/draw";
import { StringUtils } from "@sazka/utils/string-utils";
import PpAddonWinnings from "@/lotteries/product-page/components/results/pp-addon-winnings.vue";
import PpSpecialPrizeWinnings from "./pp-special-prize-winnings.vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";

defineProps<{
    results: PpDraw;
}>();

const formatNumberOfWinners = (winners: number) => ` / ${StringUtils.formatNumber(winners)}x`;
</script>
